import { ApiWrapper, PagingResults, WedocFileType, WedocQueryType, WedocTemplate, jArticleLittle } from '../../types';
import { JBaseApi } from '../base';
import { OF } from '../../util/network';

export class JWedocApi extends JBaseApi {
    public getFiles(query: WedocQueryType): Promise<ApiWrapper<PagingResults<WedocFileType>>> {
        return this.network.post({ o: 'onlyOffice', f: 'getFiles', ...query } as OF);
    }

    public getFile(idFile: number, hash?: string): Promise<ApiWrapper<WedocFileType>> {
        return this.network.post({ o: 'onlyOffice', f: 'getFile', idFile, hash } as OF);
    }

    public getTemplates(signal?: AbortSignal): Promise<ApiWrapper<WedocTemplate[]>> {
        return this.network.post({ o: 'onlyOffice', f: 'getTemplates' } as OF, signal);
    }

    public deleteFile(idFile: number, withParent?: boolean): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF({ o: 'onlyOffice', f: 'deleteFile', idFile, withParent } as OF);
    }

    public createFile(
        title: string,
        type: string,
        publishTo: string[],
    ): Promise<ApiWrapper<{ idFile: number; article: jArticleLittle }>> {
        return this.network.postCSRF<{ idFile: number; article: jArticleLittle }>({
            o: 'onlyOffice',
            f: 'createFile',
            title,
            type,
            publishTo,
        } as OF);
    }

    public updateFile(idFile: number, title: string): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF({ o: 'onlyOffice', f: 'updateFile', idFile, title } as OF);
    }

    public createVersion(idFile: number): Promise<ApiWrapper<boolean>> {
        return this.network.post({ o: 'onlyOffice', f: 'createVersion', idFile } as OF);
    }
}
